import { PresensiListComponent } from './presensi-list.component';
export default PresensiListComponent;
